
/* injects from baggage-loader */

'use strict';

export default class MainController {
    constructor($log, $state, $rootScope, $timeout, Session, Dialog, Trophies) {
        'ngInject';
        this.$log = $log;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.Session = Session;
        this.Dialog = Dialog;
        this.Trophies = Trophies;

        this.$rootScope.$on('update:status-bar', this.onUpdateStatus.bind(this))
    }

    $onInit(){
        let { stages, user } = this.Session.get();

        this.stages = stages;
        this.user = user;
                
        if (!this.stages) return false;        
    }    

    toStageOne(){
        this.$state.go('main.stage-one')
    }
    toStageTwo(){
        if(this.user.level >= 1) this.$state.go('main.stage-two')
    }
    toStageThree(){
        if (this.user.level >= 2) this.$state.go('main.stage-three')
    }
    toStageFour(){
        if (this.user.level >= 3) this.$state.go('main.stage-four')
    }

    onUpdateStatus(){
        this.user = this.Session.get().user;
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/main/main.controller.js